module.exports = __webpack_public_path__ + "img/ip-3.85cfdd70.png";